import { AddressSearchModule } from '@anb/ng-address-search';
import { CapakeySearchModule } from '@anb/ng-capakey-search';
import { AnbFormElementsModule } from '@anb/ng-forms';
import { KadasterModule } from '@anb/ng-kadaster';
import { MapModule } from '@anb/ng-maps';
import { AnbModal, AnbUIElementsModule } from '@anb/ng-ui';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgxPermissionsModule } from 'ngx-permissions';
import { IsAllowedPipe } from './pipes/is-allowed.pipe';
import { AppHeaderComponent } from './components/header/header.component';
import { BannerDesktopComponent } from './components/banner-desktop/banner-desktop.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ExceptionDialogComponent } from './components/exception-dialog/exception-dialog.component';
import { PaginatorComponent } from './components/paginator/paginator.component';

const sharedComponents = [AppHeaderComponent, BannerDesktopComponent, ExceptionDialogComponent, PaginatorComponent];

const sharedModules = [
  AnbUIElementsModule,
  AnbFormElementsModule,
  MapModule,
  AddressSearchModule,
  CapakeySearchModule,
  KadasterModule,
  MatPaginatorModule,
  ReactiveFormsModule,
  RouterModule,
  TranslateModule,
  NgxMaskDirective,
  NgxMaskPipe,
  FontAwesomeModule,
  CommonModule,
];
@NgModule({
  declarations: [...sharedComponents, PaginatorComponent],
  imports: [...sharedModules],
  exports: [NgxPermissionsModule, DatePipe, ...sharedModules, ...sharedComponents],
  providers: [AnbModal, DatePipe, IsAllowedPipe, provideNgxMask()],
})
export class SharedModule {}
